import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, DestroyRef, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-app-sub-component',
    templateUrl: './app-sub-component.component.html',
    styleUrls: ['./app-sub-component.component.scss'],
    standalone: false
})
export class AppSubComponentComponent implements OnInit {
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;

  constructor(private observer: BreakpointObserver, private destroyRef: DestroyRef) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.observer.observe(['(max-width: 700px)']).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      if (res.matches) {
        this.sidenav.mode = 'over';
        this.sidenav.close();
      } else {
        this.sidenav.mode = 'side';
        this.sidenav.open();
      }
    });
  }
}
